<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.cardiacExam') }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <b-container>
                        <div class="list-group list-group-flush">
                            <b-row>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $tc('message.types',1) }}:

                                        <span class="font-weight-bold">
                                            {{ mExamen.nom }}
                                        </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $tc('message.dates',1) }}:

                                        <span class="font-weight-bold">
                                            {{ formattedDate(mExamen.date_examen) }}
                                        </span>
                                    </div>
                                </b-col>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.description') }}:

                                        <span class="font-weight-bold">
                                            {{ mExamen.description }}
                                        </span>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col col sm="12">
                                    <b-row class="justify-content-sm-center">
                                        <div class="card-footer text-right">
                                            <b-button variant="primary" @click="updateExamenCardio" v-if="canUpdate">
                                                {{ $t('message.edit') }}
                                            </b-button>
                                            <b-button v-b-modal.delete-modal variant="danger" v-if="canDelete">
                                                {{ $t('message.delete') }}
                                            </b-button>
                                        </div>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </div>
                    </b-container>
                    <div class="card">
                        <b-modal
                                id="delete-modal"
                                size="sm"
                                header-bg-variant="danger"
                                header-text-variant="light"
                                :title="$t('message.delete') + ' ' + $t('message.cardiacExam')"
                                hide-footer
                        >
                            <div class="d-block text-center">
                                <h3>{{ $t('message.delete') }} cardio {{ formattedDate(mExamen.date_examen) }}</h3>
                            </div>

                            <div class="d-block float-right">
                                <b-button variant="danger" @click="deleteExamenCardio" >
                                    {{ $t('message.delete') }}
                                </b-button>

                                <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                    {{ $t('message.cancel') }}
                                </b-button>
                            </div>
                        </b-modal>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import moment from "moment";

    export default {
        name: "Cardiology",
        computed: {
            ...mapGetters(["cardioExam", 'hasAdminRole',
                'hasGestionnaireRole','hasPraticienRole']),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole;
            },

            canUpdate:function(){
                return this.mExamen.canUpdate;
            },

            mExamen: function () {
                return this.cardioExam;
            },

            isAuthor:function(){
                return this.mExamen.isAuthor;
            },

            canDelete:function(){
                return this.isAuthor || this.hasAdminRole;
            },

        },
        data(){
            return {
                examen: this.$route.params.cardiology,
            }
        },
        methods: {

            formattedDate(date) {
                return !_.isNull(date) ? moment(date).format('DD-MM-YYYY') : "";
            },

            getExamensCardio() {
                let args = {
                    examen: this.examen
                };

                this.$store.dispatch("getCardioExam", {args});
            },

            updateExamenCardio() {
                this.$router.push({name: 'edit-cardiology-exam', params: {cardiology: this.examen}});
            },

            deleteExamenCardio() {
                let self = this;
                let args = {
                    examen: this.examen
                };

                let successMessage = this.$i18n.t('message.cardiacExamDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteCardioExam', {args, successMessage, errorMessages}).then(() => {
                    self.$bvModal.hide('delete-modal');
                });
            },
        },

        mounted() {
            this.getExamensCardio();
        }
    }
</script>

<style scoped>

</style>